export const methods = {
    methods: {
        matchHeight(className) {
            if(typeof className === 'undefined'){
                className = 'matchHeight';
            }
            let height = 0;
            for (const key in document.getElementsByClassName(className)) {
                if (document.getElementsByClassName(className).hasOwnProperty(key)) {
                    const element = document.getElementsByClassName(className)[key];
                    if(typeof element.scrollHeight !== 'undefined'){
                        height = height < element.scrollHeight ? element.scrollHeight : height;
                    }
                }
            }
            return height;
        },
    },
}